<template>
  <v-popover
    v-if="showWarning"
    placement="bottom-end"
    trigger="hover"
    popoverClass="basic-tooltip left-aligned"
    :delay="{ show: 500, hide: 200 }"
  >
    <BaseInfoBanner
      class="documents-without-keywords-warning"
      tone="warning"
      preset="soft"
      :title="
        $tc('page.analysis.keyword-navigator.documents-without-keywords', documentsWithoutKeywords.length, {
          count: documentsWithoutKeywords.length,
        })
      "
    >
      <template #icon>
        <BaseIcon name="alert-triangle" />
      </template>
    </BaseInfoBanner>
    <template v-slot:popover>
      <p class="documents-without-keywords-warning__description">
        {{ $t('page.analysis.keyword-navigator.documents-without-keywords-description') }}
      </p>
      <div
        v-for="document in documentsWithoutKeywords"
        :key="document.id"
        class="documents-without-keywords-warning__document"
        @click="onDocumentClick(document)"
      >
        {{ document.name }}
      </div>
    </template>
  </v-popover>
</template>

<script>
import BaseIcon from '@/components/base/BaseIcon.vue';
import BaseInfoBanner from '@/components/base/BaseInfoBanner.vue';
import { isPdfFile } from '@/util/document-file-util';
import { mapGetters } from 'vuex';

export default {
  name: 'DocumentsWithoutKeywordsWarning',
  components: { BaseIcon, BaseInfoBanner },
  computed: {
    ...mapGetters('opportunityDocumentsPdfEngine', {
      pdfEnginePending: 'pending',
      pdfEngineResolved: 'resolved',
      pdfEngineError: 'error',
      matchedKwByDocument: 'matchedKwByDocument',
    }),
    ...mapGetters('documentKeywords', { documentKwPending: 'pending', keywords: 'keywords' }),
    ...mapGetters('opportunityDocuments', ['opportunityDocuments']),
    ...mapGetters('opportunityDocumentsQueue', ['hasScheduledKeywordIndexing']),
    pdfDocuments() {
      return this.opportunityDocuments.filter((doc) => isPdfFile(doc));
    },
    documentIdsWithKeywords() {
      return new Set(this.matchedKwByDocument.filter((match) => match.occurrences > 0).map((match) => match.docId));
    },
    documentsWithoutKeywords() {
      return this.pdfDocuments.filter((doc) => !this.documentIdsWithKeywords.has(doc.id));
    },
    showWarning() {
      return (
        this.documentsWithoutKeywords.length > 0 &&
        this.keywords.length > 0 &&
        this.pdfEngineResolved &&
        !this.pdfEngineError &&
        !this.pdfEnginePending &&
        !this.documentKwPending &&
        !this.hasScheduledKeywordIndexing
      );
    },
  },
  methods: {
    onDocumentClick(document) {
      this.$emit('document-click', document);
    },
  },
};
</script>

<style lang="scss">
.documents-without-keywords-warning {
  cursor: default;

  &__description {
    margin: 0 0 8px;
    font-size: 12px;
    line-height: 1.4;
  }

  &__document {
    font-size: 12px;
    padding: 4px 0;
    cursor: pointer;

    &:hover {
      color: $color-accent;
    }
  }
}
</style>
